import {Component, EventEmitter, input, OnDestroy, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';

type AssessorButtonType = 'default' | 'submit' | 'cancel';

@Component({
    selector: 'app-assessor-button',
    imports: [
        NgbTooltip
    ],
    templateUrl: './assessor-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './assessor-button.component.scss'
})
export class AssessorButtonComponent implements OnInit, OnDestroy {
  buttonType = input<AssessorButtonType>('default');
  leadingIcon = input<string>();
  trailingIcon = input<string>();
  title = input.required<string>();
  tooltip = input<string>();
  isDisabled = input<boolean>(false);

  buttonClass = 'btn-assessor';

  private sub: Subscription;
  private clickSubject = new Subject<MouseEvent>();
  @Output() clickEvent = new EventEmitter<MouseEvent>();

  constructor() {
    this.sub = this.clickSubject.subscribe(event => this.clickEvent.emit(event));
  }

  ngOnInit(): void {
    switch (this.buttonType()) {
      case 'default':
        this.buttonClass = 'btn-assessor';
        break;
      case 'submit':
        this.buttonClass = 'btn-submit';
        break;
      case 'cancel':
        this.buttonClass = 'btn-danger';
        break;
    }
  }

  onClick(event: MouseEvent): void {
    this.clickSubject.next(event);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
